import numeral from 'numeral';
import moment from 'moment';
import PluginZoom from 'chartjs-plugin-zoom';
import * as appColors from '@/functions/appColors';
import tooltipTitle from '@/functions/chartTooltipDate';

export const container = data => ({
    type: 'line',
    data,
    plugins: [PluginZoom],
    options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            mode: 'x',
            intersect: false,
            position: 'nearest',
            callbacks: {
                label(tooltipItem, d) {
                    const label = d.datasets[tooltipItem.datasetIndex].label || '';
                    const value = numeral(tooltipItem.yLabel).format('0,0.[00]');
                    return `${label}: ${value} cm`;
                },
                title: tooltipTitle,
            },
        },
        annotation: {
            events: [],
            annotations: [
                {
                    drawTime: 'afterDatasetsDraw',
                    id: 'vline',
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: moment(),
                    borderColor: 'black',
                    borderWidth: 3,
                    label: {
                        backgroundColor: appColors.todayMarker,
                        content: moment().format('LL'),
                        enabled: true,
                    },
                },
            ],
        },
        pan: {
            enabled: true,
            mode: 'y',
            speed: 10,
            threshold: 10,
        },
        zoom: {
            enabled: true,
            mode: 'y',
            limits: {
                max: 100,
                min: 1,
            },
        },
        scales: {
            xAxes: [
                {
                    type: 'time',
                    distribution: 'linear',
                    time: {
                        tooltipFormat: 'MMM DD, YYYY',
                        unit: 'month',
                    },
                },
            ],
            yAxes: [
                {
                    scaleLabel: {
                        display: true,
                        labelString: 'Snow Depth (cm)',
                    },
                },
            ],
            // disable animations
            animation: false,
        },
    },
});

export const data = (label, currentData, historicalData) => ({
    labels: label,
    datasets: [
        {
            type: 'line',
            label: 'Current Snow Depth',
            borderColor: appColors.currentBorder,
            backgroundColor: appColors.currentBg,
            borderWidth: 2,
            fill: true,
            pointRadius: 0,
            pointHitRadius: 1,
            // steppedLine: 'before',
            data: currentData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.v,
                };
                return valObj;
            }),
        },
        {
            type: 'line',
            label: 'Historical mean',
            borderColor: appColors.historicalMean,
            backgroundColor: appColors.historicalMean,
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.a,
                };
                return valObj;
            }),
        },
        {
            type: 'line',
            label: 'Historical 75th %ile',
            borderColor: appColors.historical1,
            backgroundColor: appColors.historical1,
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.p75,
                };
                return valObj;
            }),
        },
        {
            type: 'line',
            label: 'Historical 25th %ile',
            borderColor: appColors.historical1,
            backgroundColor: appColors.historical1,
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.p25,
                };
                return valObj;
            }),
        },
        {
            type: 'line',
            label: 'Historical 90th %ile',
            borderColor: appColors.historical2,
            backgroundColor: appColors.historical2,
            borderWidth: 2,
            fill: '+1',
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.p90,
                };
                return valObj;
            }),
        },
        {
            type: 'line',
            label: 'Historical 10th %ile',
            borderColor: appColors.historical2,
            backgroundColor: appColors.historical2,
            borderWidth: 2,
            fill: false,
            steppedLine: 'before',
            pointRadius: 0,
            // pointHitRadius: 1,
            data: historicalData.map((d) => {
                const valObj = {
                    x: d.d,
                    y: d.p10,
                };
                return valObj;
            }),
        },
    ],
});



// WEBPACK FOOTER //
// ./src/chartData/climateSnowChart.js